query getLeadsStatusesStatistics($isMasterView: Boolean, $childCompanyId: ID) {
    getLeadsStatusesStatistics: getLeadsStatusesStatistics(isMasterView: $isMasterView, childCompanyId: $childCompanyId) {
        companyName
        companyId
        statuses {
           status
           count
        }
    }
}
